// extracted by mini-css-extract-plugin
export default {"albumPage":"albumPage_albumPage__5W0uq","grid":"albumPage_grid__bCUr8","backLink":"albumPage_backLink__YKYnC","loaderWrapper":"albumPage_loaderWrapper__4fM7n"};